import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SltDataServiceRequestService {

  constructor(private http: HttpClient) { }

  /**
   * Get request JSON data by LOG_ID
   * @param baseUrl - The base URL for API calls
   * @param logId - The LOG_ID to fetch request data for
   * @returns Observable with the request JSON data
   */
  getRequestJson(baseUrl: string, logId: string | number): Observable<any> {
    // Build URL with query parameters (following AngularJS pattern)
    const url = `${baseUrl}/loadJsonObject?action_id=32777&log_id=${logId}`;
    
    // Use GET request as in original AngularJS service
    return this.http.get<any>(url, { 
      withCredentials: true 
    });
  }
}

